import React, { useState } from "react"
import { useNavigate } from "react-router-dom"
import { useAuth } from "../../context/AuthContext"
import "./auth.css"

const AdminLogin = () => {
  const { adminLogin } = useAuth()
  const navigate       = useNavigate()
  const [form, setForm]       = useState({ email: "", password: "" })
  const [error, setError]     = useState("")
  const [loading, setLoading] = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError("")
    setLoading(true)
    try {
      await adminLogin(form.email, form.password)
      navigate("/admin/dashboard")
    } catch (err) {
      setError(err.response?.data?.message || "Invalid credentials.")
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="auth-page">
      <div className="auth-card">

        {/* Logo */}
        <div className="auth-logo">
          <img src="/images/logo.png" alt="Rovers Access" />
        </div>

        {/* Badge — no text that reveals it's "admin" to casual visitors */}
        <div className="auth-admin-badge">
          <i className="fa fa-lock"></i> Secure Access Portal
        </div>

        <h2>Sign In</h2>
        <p className="auth-sub">Authorised personnel only</p>

        {error && (
          <div className="auth-error">
            <i className="fa fa-exclamation-circle"></i> {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="auth-field">
            <label>Email</label>
            <input
              type="email"
              placeholder="Enter your email"
              value={form.email}
              onChange={e => setForm({ ...form, email: e.target.value })}
              required
              autoFocus
            />
          </div>
          <div className="auth-field">
            <label>Password</label>
            <input
              type="password"
              placeholder="••••••••"
              value={form.password}
              onChange={e => setForm({ ...form, password: e.target.value })}
              required
            />
          </div>
          <button type="submit" className="auth-btn" disabled={loading}>
            {loading
              ? <><i className="fa fa-spinner fa-spin"></i> Verifying…</>
              : <><i className="fa fa-sign-in-alt"></i> Sign In</>
            }
          </button>
        </form>

        {/* No links — intentionally isolated */}
        <p style={{ textAlign: "center", marginTop: 20, fontSize: 12, color: "rgba(255,255,255,0.2)" }}>
          © 2026 Rovers Access Limited
        </p>

      </div>
    </div>
  )
}

export default AdminLogin
